module.exports = __webpack_public_path__ + "img/informe-citas.228ad998.svg";